<template>
	<div>
		<div :class="['mb-3', compact ? 'promo-step__actions' : 'd-flex flex-wrap justify-end ga-2']">
			<v-btn prepend-icon="view_timeline" :block="compact" @click="ops.run({ type: 'gotoPromoPlanning' })">{{ t('PromoPlanning') }}</v-btn>
			<v-btn prepend-icon="description" color="primary" :block="compact" @click="ops.generatePromoPlan()">{{ t('SFA PlanPromo') }}</v-btn>
		</div>
		<v-row density="compact" class="mb-2">
			<v-col v-for="kpi in kpis" :key="kpi.key" cols="6" md>
				<v-card variant="tonal" color="primary" class="pa-3 text-center h-100">
					<div class="text-title-large font-weight-bold">{{ kpi.value }}</div>
					<div class="text-body-small">{{ kpi.label }}</div>
				</v-card>
			</v-col>
		</v-row>
		<v-textarea :model-value="header.globalComment" :label="t('CommentPublicPromo')" rows="2" auto-grow variant="outlined" :disabled="!header.globalCommentEditable" @change="(event) => ops.setGlobalComment(event.target.value)" />
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { usePromoStep } from '@/composables/usePromoStep';

const { snapshot, compact, ops, t } = usePromoStep();

const header = computed(() => snapshot.value.header);

const kpis = computed(() => {
	const values = header.value.kpis || {};
	return [
		{ key: 'nbToNego', value: values.nbToNego, label: t('TitleNbToNego') },
		{ key: 'volumeToNego', value: values.volumeToNego, label: t('TitleVolumeToNego') },
		{ key: 'caNego', value: values.caNego, label: `${snapshot.value.currency} ${t('TitleCANego')}` },
		{ key: 'nbToState', value: values.nbToState, label: t('TitleNbToState') },
		{ key: 'volumeToState', value: values.volumeToState, label: t('TitleVolumeToState') },
	];
});
</script>
